export default "__VITE_ASSET__CzdZ3HqsUD7AuSXK$ZHwZQ__"